import { SxProps, Theme } from "@mui/material/styles";

export const captainProfileContainer: SxProps<Theme> = (theme) => ({
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.primary,
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    overflowY: "auto",
    padding: 0,
    margin: 0,
    boxShadow: "none",
});

export const backButton: SxProps<Theme> = {
    position: "fixed",
    top: 30,
    left: 10,
    zIndex: 1000,
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    width: "35px",
    height: "35px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};
